import React, { Suspense, useEffect } from "react";
import { Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import FallbackSpinner from "./@core/components/spinner";
import UserLayout from "./layouts/UserLayout";
import BlankLayout from "./@core/layouts/BlankLayout";
import "../src/App.css";
import AuthLayout from "./layouts/AuthLayout";
import { useTranslation } from "react-i18next";

const HomePage = React.lazy(() => import("./pages/home"));
const ConfirmOrderPage = React.lazy(() =>
  import("./pages/confirm-order/ConfirmOrderPage")
);
const PaymentSuccessFull = React.lazy(() =>
  import("./pages/payment-successfull/PaymentSuccessFull")
);
const AboutUsPage = React.lazy(() => import("./pages/about-us"));
const ServicesPage = React.lazy(() => import("./pages/services"));
const OrderManagementPage = React.lazy(() =>
  import("./pages/order-management")
);
const DriverApplicationPage = React.lazy(() =>
  import("./pages/driver-application")
);
const BlogsPage = React.lazy(() => import("./pages/blog"));
const BlogDetailsPage = React.lazy(() => import("./pages/blog-details"));
const ContactUsPage = React.lazy(() => import("./pages/contact-us"));
const FAQsPage = React.lazy(() => import("./pages/faqs"));
const PrivacyPolicyPage = React.lazy(() => import("./pages/privacy-policy"));
const TermsAndConditionPage = React.lazy(() =>
  import("./pages/terms-and-conditions")
);

const Page401 = React.lazy(() => import("./pages/401"));
const Page404 = React.lazy(() => import("./pages/404"));

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language) {
      document.documentElement.setAttribute("lang", i18n.language);
      document.documentElement.setAttribute("dir", i18n.language === "ar" ? "rtl" : "ltr");
    }
  }, [i18n.language]);

  return (
    <Suspense fallback={<FallbackSpinner />}>
      <Routes>
        <Route
          element={
            <BlankLayout>
              <Outlet />
            </BlankLayout>
          }
        >
          <Route path="/401" element={<Page401 />} />
          <Route path="/404" element={<Page404 />} />
          <Route path="/payment-successfull" element={<PaymentSuccessFull />} />
          <Route
            element={
              <AuthLayout>
                <Outlet />
              </AuthLayout>
            }
          >
            <Route path="/confirm-order" element={<ConfirmOrderPage />} />
          </Route>
        </Route>
        <Route
          element={
            <UserLayout>
              <Outlet />
            </UserLayout>
          }
        >
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/order-management" element={<OrderManagementPage />} />
          <Route
            path="/driver-application"
            element={<DriverApplicationPage />}
          />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/blog" element={<BlogsPage />} />
          <Route path="/blog-details/:id" element={<BlogDetailsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionPage />}
          />
        </Route>

        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
